import { EntityTypes } from './enums/entityTypes';
import { SupplierReportTypes } from './enums/supplierReportTypes';

export interface SupplierReportLink {
  reportId: string;
  supplierId: string;
  reportType: SupplierReportTypes;
  filePath: string;
  entityType: EntityTypes.supplierReportLink;
  created: number;
  lastUpdated: number;
  expiresAt: number;
}

export interface SupplierReportMessage {
  supplierReportLink: string;
  firstName: string;
  email: string;
}